// AUTO-GENERATED from public/player/ (armor excluded — it is crafted gear, not creator cosmetics). Do not edit by hand.
export interface PresetColor { label: string; file: string }
export interface CharStyle { id: string; label: string; presets: PresetColor[] }
export interface CharSlot { id: string; label: string; z: number; optional: boolean; recolor: boolean; styles: CharStyle[] }
export const FRAME_W = 64;
export const FRAME_H = 64;
export const CHAR_SLOTS: CharSlot[] = [
  {
    "id": "skin",
    "label": "Skin",
    "z": 0,
    "optional": false,
    "recolor": true,
    "styles": [
      {
        "id": "base",
        "label": "Body",
        "presets": [
          {
            "label": "Default",
            "file": "Player_Base/Player_Base_animations.png"
          }
        ]
      }
    ]
  },
  {
    "id": "pants",
    "label": "Pants",
    "z": 1,
    "optional": false,
    "recolor": true,
    "styles": [
      {
        "id": "Farmer_Pants",
        "label": "Farmer Pants",
        "presets": [
          {
            "label": "Black",
            "file": "Legs/Farmer_Pants/Farmer_Pants_1_Black.png"
          },
          {
            "label": "Blue",
            "file": "Legs/Farmer_Pants/Farmer_Pants_1_Blue.png"
          },
          {
            "label": "Green",
            "file": "Legs/Farmer_Pants/Farmer_Pants_1_Green.png"
          },
          {
            "label": "Orange",
            "file": "Legs/Farmer_Pants/Farmer_Pants_1_Orange.png"
          },
          {
            "label": "Pink",
            "file": "Legs/Farmer_Pants/Farmer_Pants_1_Pink.png"
          },
          {
            "label": "Purple",
            "file": "Legs/Farmer_Pants/Farmer_Pants_1_Purple.png"
          },
          {
            "label": "Red",
            "file": "Legs/Farmer_Pants/Farmer_Pants_1_Red.png"
          },
          {
            "label": "White and Brown",
            "file": "Legs/Farmer_Pants/Farmer_Pants_1_White_and_Brown.png"
          }
        ]
      },
      {
        "id": "OG_Pants",
        "label": "OG Pants",
        "presets": [
          {
            "label": "Black",
            "file": "Legs/OG_Pants/Pants_1_Black.png"
          },
          {
            "label": "Blue",
            "file": "Legs/OG_Pants/Pants_1_Blue.png"
          },
          {
            "label": "Brown",
            "file": "Legs/OG_Pants/Pants_1_Brown.png"
          },
          {
            "label": "Green",
            "file": "Legs/OG_Pants/Pants_1_Green.png"
          },
          {
            "label": "Orange",
            "file": "Legs/OG_Pants/Pants_1_Orange.png"
          },
          {
            "label": "Pink",
            "file": "Legs/OG_Pants/Pants_1_Pink.png"
          },
          {
            "label": "Purple",
            "file": "Legs/OG_Pants/Pants_1_Purple.png"
          },
          {
            "label": "Red",
            "file": "Legs/OG_Pants/Pants_1_Red.png"
          }
        ]
      },
      {
        "id": "Royal_Pants",
        "label": "Royal Pants",
        "presets": [
          {
            "label": "1 Black",
            "file": "Legs/Royal_Pants/Royal_Pants_1_Black.png"
          },
          {
            "label": "1 Blue",
            "file": "Legs/Royal_Pants/Royal_Pants_1_Blue.png"
          },
          {
            "label": "1 Green",
            "file": "Legs/Royal_Pants/Royal_Pants_1_Green.png"
          },
          {
            "label": "1 Orange",
            "file": "Legs/Royal_Pants/Royal_Pants_1_Orange.png"
          },
          {
            "label": "1 Purple",
            "file": "Legs/Royal_Pants/Royal_Pants_1_Purple.png"
          },
          {
            "label": "1 White",
            "file": "Legs/Royal_Pants/Royal_Pants_1_White.png"
          },
          {
            "label": "t 1 Red",
            "file": "Legs/Royal_Pants/Royal_Pantst_1_Red.png"
          }
        ]
      }
    ]
  },
  {
    "id": "shoes",
    "label": "Shoes",
    "z": 2,
    "optional": true,
    "recolor": true,
    "styles": [
      {
        "id": "shoes",
        "label": "Shoes",
        "presets": [
          {
            "label": "Black",
            "file": "Feet/Shoes_1_Black.png"
          },
          {
            "label": "Blue",
            "file": "Feet/Shoes_1_Blue.png"
          },
          {
            "label": "Brown",
            "file": "Feet/Shoes_1_Brown.png"
          },
          {
            "label": "Green",
            "file": "Feet/Shoes_1_Green.png"
          },
          {
            "label": "Orange",
            "file": "Feet/Shoes_1_Orange.png"
          },
          {
            "label": "Pink",
            "file": "Feet/Shoes_1_Pink.png"
          },
          {
            "label": "Purple",
            "file": "Feet/Shoes_1_Purple.png"
          },
          {
            "label": "Red",
            "file": "Feet/Shoes_1_Red.png"
          },
          {
            "label": "White",
            "file": "Feet/Shoes_1_White.png"
          }
        ]
      }
    ]
  },
  {
    "id": "shirt",
    "label": "Shirt",
    "z": 3,
    "optional": false,
    "recolor": true,
    "styles": [
      {
        "id": "Farmer_Shirt",
        "label": "Farmer Shirt",
        "presets": [
          {
            "label": "Black",
            "file": "Chest/Farmer_Shirt/Farmer_Shirt_1_Black.png"
          },
          {
            "label": "Blue",
            "file": "Chest/Farmer_Shirt/Farmer_Shirt_1_Blue.png"
          },
          {
            "label": "Green",
            "file": "Chest/Farmer_Shirt/Farmer_Shirt_1_Green.png"
          },
          {
            "label": "Orange",
            "file": "Chest/Farmer_Shirt/Farmer_Shirt_1_Orange.png"
          },
          {
            "label": "Pink",
            "file": "Chest/Farmer_Shirt/Farmer_Shirt_1_Pink.png"
          },
          {
            "label": "Purple",
            "file": "Chest/Farmer_Shirt/Farmer_Shirt_1_Purple.png"
          },
          {
            "label": "Red",
            "file": "Chest/Farmer_Shirt/Farmer_Shirt_1_Red.png"
          },
          {
            "label": "White and Brown",
            "file": "Chest/Farmer_Shirt/Farmer_Shirt_1_White_and_Brown.png"
          }
        ]
      },
      {
        "id": "Lumberjack_Shirt",
        "label": "Lumberjack Shirt",
        "presets": [
          {
            "label": "Black",
            "file": "Chest/Lumberjack_Shirt/Lumberjack_Shirt_1_Black.png"
          },
          {
            "label": "Blue",
            "file": "Chest/Lumberjack_Shirt/Lumberjack_Shirt_1_Blue.png"
          },
          {
            "label": "Brown",
            "file": "Chest/Lumberjack_Shirt/Lumberjack_Shirt_1_Brown.png"
          },
          {
            "label": "Green",
            "file": "Chest/Lumberjack_Shirt/Lumberjack_Shirt_1_Green.png"
          },
          {
            "label": "Orange",
            "file": "Chest/Lumberjack_Shirt/Lumberjack_Shirt_1_Orange.png"
          },
          {
            "label": "Pink",
            "file": "Chest/Lumberjack_Shirt/Lumberjack_Shirt_1_Pink.png"
          },
          {
            "label": "Purple",
            "file": "Chest/Lumberjack_Shirt/Lumberjack_Shirt_1_Purple.png"
          },
          {
            "label": "Red",
            "file": "Chest/Lumberjack_Shirt/Lumberjack_Shirt_1_Red.png"
          },
          {
            "label": "White",
            "file": "Chest/Lumberjack_Shirt/Lumberjack_Shirt_1_White.png"
          }
        ]
      },
      {
        "id": "OG_Shirt",
        "label": "OG Shirt",
        "presets": [
          {
            "label": "Black",
            "file": "Chest/OG_Shirt/Shirt_1_Black.png"
          },
          {
            "label": "Blue",
            "file": "Chest/OG_Shirt/Shirt_1_Blue.png"
          },
          {
            "label": "Brown",
            "file": "Chest/OG_Shirt/Shirt_1_Brown.png"
          },
          {
            "label": "Green",
            "file": "Chest/OG_Shirt/Shirt_1_Green.png"
          },
          {
            "label": "Orange",
            "file": "Chest/OG_Shirt/Shirt_1_Orange.png"
          },
          {
            "label": "Pink",
            "file": "Chest/OG_Shirt/Shirt_1_Pink.png"
          },
          {
            "label": "Purple",
            "file": "Chest/OG_Shirt/Shirt_1_Purple.png"
          },
          {
            "label": "Red",
            "file": "Chest/OG_Shirt/Shirt_1_Red.png"
          }
        ]
      },
      {
        "id": "Royal_Shirt",
        "label": "Royal Shirt",
        "presets": [
          {
            "label": "Black",
            "file": "Chest/Royal_Shirt/Royal_Shirt_1_Black.png"
          },
          {
            "label": "Blue",
            "file": "Chest/Royal_Shirt/Royal_Shirt_1_Blue.png"
          },
          {
            "label": "Green",
            "file": "Chest/Royal_Shirt/Royal_Shirt_1_Green.png"
          },
          {
            "label": "Orange",
            "file": "Chest/Royal_Shirt/Royal_Shirt_1_Orange.png"
          },
          {
            "label": "Purple",
            "file": "Chest/Royal_Shirt/Royal_Shirt_1_Purple.png"
          },
          {
            "label": "Red",
            "file": "Chest/Royal_Shirt/Royal_Shirt_1_Red.png"
          },
          {
            "label": "White",
            "file": "Chest/Royal_Shirt/Royal_Shirt_1_White.png"
          }
        ]
      }
    ]
  },
  {
    "id": "hair",
    "label": "Hair",
    "z": 5,
    "optional": true,
    "recolor": true,
    "styles": [
      {
        "id": "Hair_1",
        "label": "Hair 1",
        "presets": [
          {
            "label": "Black",
            "file": "Head/Hair_1/Hair_1_Black.png"
          },
          {
            "label": "Blonde",
            "file": "Head/Hair_1/Hair_1_Blonde.png"
          },
          {
            "label": "Brown",
            "file": "Head/Hair_1/Hair_1_Brown.png"
          },
          {
            "label": "Ginger",
            "file": "Head/Hair_1/Hair_1_Ginger.png"
          },
          {
            "label": "Grey",
            "file": "Head/Hair_1/Hair_1_Grey.png"
          }
        ]
      },
      {
        "id": "Hair_2",
        "label": "Hair 2",
        "presets": [
          {
            "label": "Black",
            "file": "Head/Hair_2/Hair_2_Black.png"
          },
          {
            "label": "Blonde",
            "file": "Head/Hair_2/Hair_2_Blonde.png"
          },
          {
            "label": "Brown",
            "file": "Head/Hair_2/Hair_2_Brown.png"
          },
          {
            "label": "Ginger",
            "file": "Head/Hair_2/Hair_2_Ginger.png"
          },
          {
            "label": "Grey",
            "file": "Head/Hair_2/Hair_2_Grey.png"
          }
        ]
      },
      {
        "id": "Hair_3",
        "label": "Hair 3",
        "presets": [
          {
            "label": "Black",
            "file": "Head/Hair_3/Hair_3_Black.png"
          },
          {
            "label": "Blonde",
            "file": "Head/Hair_3/Hair_3_Blonde.png"
          },
          {
            "label": "Brown",
            "file": "Head/Hair_3/Hair_3_Brown.png"
          },
          {
            "label": "Ginger",
            "file": "Head/Hair_3/Hair_3_Ginger.png"
          },
          {
            "label": "Grey",
            "file": "Head/Hair_3/Hair_3_Grey.png"
          }
        ]
      },
      {
        "id": "Hair_4",
        "label": "Hair 4",
        "presets": [
          {
            "label": "Black",
            "file": "Head/Hair_4/Hair_4_Black.png"
          },
          {
            "label": "Blonde",
            "file": "Head/Hair_4/Hair_4_Blonde.png"
          },
          {
            "label": "Brown",
            "file": "Head/Hair_4/Hair_4_Brown.png"
          },
          {
            "label": "Ginger",
            "file": "Head/Hair_4/Hair_4_Ginger.png"
          },
          {
            "label": "Grey",
            "file": "Head/Hair_4/Hair_4_Grey.png"
          }
        ]
      },
      {
        "id": "Hair_5",
        "label": "Hair 5",
        "presets": [
          {
            "label": "Black",
            "file": "Head/Hair_5/Hair_5_Black.png"
          },
          {
            "label": "Blonde",
            "file": "Head/Hair_5/Hair_5_Blonde.png"
          },
          {
            "label": "Brown",
            "file": "Head/Hair_5/Hair_5_Brown.png"
          },
          {
            "label": "Ginger",
            "file": "Head/Hair_5/Hair_5_Ginger.png"
          },
          {
            "label": "Grey",
            "file": "Head/Hair_5/Hair_5_Grey.png"
          }
        ]
      },
      {
        "id": "Hair_6",
        "label": "Hair 6",
        "presets": [
          {
            "label": "Black",
            "file": "Head/Hair_6/Hair_6_Black.png"
          },
          {
            "label": "Blonde",
            "file": "Head/Hair_6/Hair_6_Blonde.png"
          },
          {
            "label": "Brown",
            "file": "Head/Hair_6/Hair_6_Brown.png"
          },
          {
            "label": "Ginger",
            "file": "Head/Hair_6/Hair_6_Ginger.png"
          },
          {
            "label": "Grey",
            "file": "Head/Hair_6/Hair_6_Grey.png"
          }
        ]
      }
    ]
  },
  {
    "id": "headgear",
    "label": "Hat",
    "z": 6,
    "optional": true,
    "recolor": true,
    "styles": [
      {
        "id": "farmer_hat",
        "label": "Farmer Hat",
        "presets": [
          {
            "label": "Default",
            "file": "Accessories/Farmer_Hat_1.png"
          }
        ]
      }
    ]
  }
];
